import './App.css';
import Weather from "./Weather"



export default function App() {
  return (
    <div>
      <Weather />
    </div>
  );
}
